const curriculumId = 'curriculum-tabs';
const curriculumTabActiveClass = 'curriculum-tab--active';
const curriculumTriggerActiveClass = 'curriculum-sidebar-item--active';

const curriculumTriggerSelector = '.curriculum-sidebar-item';
const curriculumTabSelector = '.curriculum-tab';

function initializeCurriculum() {
  const curriculumEl = document.getElementById(curriculumId);

  if (!curriculumEl) {
    // eslint-disable-next-line
    console.error('Curriculum not found');
    return;
  }

  const triggerEls = curriculumEl.querySelectorAll(curriculumTriggerSelector);
  const tabEls = curriculumEl.querySelectorAll(curriculumTabSelector);

  function handleTabOpen() {
    triggerEls.forEach(
      triggerEl => triggerEl.classList.remove(curriculumTriggerActiveClass),
    );
    tabEls.forEach(tabEl => tabEl.classList.remove(curriculumTabActiveClass));

    const index = this.getAttribute('data-index');
    const tabEl = curriculumEl
      .querySelector(`${curriculumTabSelector}[data-index="${index}"]`);

    this.classList.add(curriculumTriggerActiveClass);
    tabEl.classList.add(curriculumTabActiveClass);
  }

  triggerEls.forEach(
    triggerEl => triggerEl.addEventListener('click', handleTabOpen),
  );
}

export default {
  initialize: initializeCurriculum,
};
